import { Component, OnInit } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { FunctionsService } from 'src/app/services/functions/functions.service';

@Component({
  selector: 'app-manager-reports-detail',
  templateUrl: './manager-reports-detail.page.html',
  styleUrls: ['./manager-reports-detail.page.scss'],
})
export class ManagerReportsDetailPage implements OnInit {
  row: any;

  constructor(
    private navParams: NavParams,
    public funcServ: FunctionsService,
    public modalCtrl: ModalController) { }

  ngOnInit() {
    this.row = this.navParams.get('row');
    console.log(this.row);
  }

}
